// ======================================================================
// File Name       : ContentNewBigQuestion
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Col, Button, Form } from 'react-bootstrap';
import ContentSubQuestionList from '../../components/content/ContentSubQuestionList';
import ContentBigQuestionAdvanced from '../../components/content/ContentBigQuestionAdvanced';
import ContentSubQuestionDialog from '../../components/content/ContentSubQuestionDialog';
import FileUpload from '../../components/FileUpload';
import { VALIDATE_TYPE, ROOT_URL } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';

class ContentNewBigQuestion extends Component {
  constructor(props) {
    super(props);
    this.openAddSubQuestionDialog = this.openAddSubQuestionDialog.bind(this);
    this.onAddSubQuestionDialogCancel = this.onAddSubQuestionDialogCancel.bind(this);
    this.handleOkBtnClick = this.handleOkBtnClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.handleQuestionFileChange = this.handleQuestionFileChange.bind(this);
    this.onAddSubQuestion = this.onAddSubQuestion.bind(this);
    this.openEditSubQuestionDialog = this.openEditSubQuestionDialog.bind(this);
    this.validation = this.validation.bind(this);
  }
  openAddSubQuestionDialog() {
    this.props.updateSubQuestionTemplate(null);
    this.props.onClickAddBtn(true);
  }
  onAddSubQuestionDialogCancel() {
    this.props.onClickAddBtn(false);
  }

  handleOkBtnClick() {
    this.props.onOkBtnClick();
  }

  onChange(name, value) {
    this.props.onInputChange(name, value);
  }

  onCheckboxChange(event) {
    this.props.handleCheckboxChange(event);
  }

  handleQuestionFileChange(event) {
    this.props.handleQuestionPartHtmlFileChange(event);
  }

  onAddSubQuestion(subQuestion) {
    this.props.handleAddSubQuestion(subQuestion);
  }

  openEditSubQuestionDialog(subQuestionDetail) {
    this.props.updateSubQuestionTemplate(subQuestionDetail);
    this.props.onClickAddBtn(true);
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      hintUse,
      hintHtmlUse,
      hintZipFileName,
      questionZipFileName,
      explanationUse,
      explanationHtmlUse,
      explanationZipFileName,
      questionKind,
      showAddSubQuestionModal,
      onClickAddBtn,
      limitTime,
      subQuestionArray,
      onOkBtnClick,
      onInputChange,
      handleCheckboxChange,
      handleHintHtmlFileChange,
      handleExplanationHtmlFileChange,
      handleQuestionPartHtmlFileChange,
      handleAddSubQuestion,
      handleRemoveSubQuestion,
      subQuestionTemplate,
      updateSubQuestionTemplate,
      openOrCloseAdvanceSetting,
      buttonText,
      isClosedAdvanceSetting,
      isRegister,
      hintContent,
      explanationContent,
    } = this.props;
    this.refsToValidate = [];
    if (!(parseInt(questionKind, 10) === 1)) {
      return null;
    }
    return (
      <div className="col-sm-12">
        <Form.Group className="form-info">
          <Col sm={4}>
            <Col as={Form.Label} sm={12}>
              問題フォーマット
              {isRegister ? <span className="required">&nbsp;(※)</span> : null}
            </Col>
            <Col as={Form.Label} sm={12} className="margin-bottom-10">
              <a
                className="float-start"
                role="button"
                href={ROOT_URL + "/manual/csvsample/bigQuestion_content.zip"}
              >
                <u>サンプルダウンロード</u>
              </a>
            </Col>
          </Col>
          <Col sm={7} className="margin-left-right-minus-15 margin-top-10">
            <FileUpload
              labelName="ファイル選択"
              fileName={questionZipFileName}
              onChange={this.handleQuestionFileChange}
              accept={
                "application/zip,application/x-zip,application/x-zip-compressed"
              }
              inputId={"questionZipFile"}
            />
          </Col>
          <Col
            sm={{
              span: 7,
              offset: 4,
            }}
            className="margin-bottom-20"
          >
            <FormControlValidate
              label="問題内容"
              validateType={VALIDATE_TYPE.LABEL}
              value={
                questionZipFileName && `ファイル名：${questionZipFileName}`
              }
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              required={isRegister}
            />
          </Col>
          <Col as={Form.Label} sm={4}>
            小問の設定<span className="required">&nbsp;(※)</span>
          </Col>
          <Col sm={7}>
            <Button
              variant="primary"
              className="btn-96 padding-left-right-40"
              onClick={this.openAddSubQuestionDialog}
            >
              追加
            </Button>
          </Col>
        </Form.Group>

        <ContentSubQuestionList
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          subQuestionArray={subQuestionArray}
          handleRemoveSubQuestion={handleRemoveSubQuestion}
          openEditSubQuestionDialog={this.openEditSubQuestionDialog}
          isRegister={isRegister}
        />
        {/* Advance setting */}
        <Form.Group className="form-info margin-top-20">
          <Col sm={3} as={Form.Label} className="padding-left-5 margin-bottom-10">
            <a
              role="presentation"
              className={buttonText}
              onClick={openOrCloseAdvanceSetting}
            >
              詳細設定
            </a>
          </Col>
        </Form.Group>
        {isClosedAdvanceSetting === false && (
          <ContentBigQuestionAdvanced
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            limitTime={limitTime}
            onInputChange={this.onChange}
            onCheckboxChange={this.onCheckboxChange}
            hintUse={hintUse}
            explanationUse={explanationUse}
            hintHtmlUse={hintHtmlUse}
            hintZipFileName={hintZipFileName}
            explanationHtmlUse={explanationHtmlUse}
            explanationZipFileName={explanationZipFileName}
            handleHintHtmlFileChange={handleHintHtmlFileChange}
            handleExplanationHtmlFileChange={handleExplanationHtmlFileChange}
            hintContent={hintContent}
            explanationContent={explanationContent}
          />
        )}
        <Col sm={12} className="text-center margin-top-20 margin-bottom-10">
          <Button
            variant="primary"
            className="btn-96"
            onClick={this.handleOkBtnClick}
          >
            OK
          </Button>
        </Col>
        <ContentSubQuestionDialog
          subQuestionArray={subQuestionArray}
          show={showAddSubQuestionModal}
          subQuestionIndex={subQuestionTemplate.subQuestionIndex}
          subQuestionSecernId={subQuestionTemplate.subQuestionSecernId}
          subAbsolutePoint={subQuestionTemplate.subAbsolutePoint}
          subAnswerFormula={subQuestionTemplate.subAnswerFormula}
          onOkClick={this.onAddSubQuestion}
          onCancelClick={this.onAddSubQuestionDialogCancel}
          addSubQuestionFunc={this.onAddSubQuestion}
          updateSubQuestionTemplate={updateSubQuestionTemplate}
        />
      </div>
    );
  }
}

export default ContentNewBigQuestion;
